import Box from "@/common/components/Box";
import Skeleton from "@/common/components/Skeleton";

const MaintenanceEstablishmentChoiceAuctionEntriesShowLoading = () => {
  return (
    <div className="flex-1 flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <Box className="flex-1 p-3 rounded-lg flex flex-col gap-2 h-24">
          <div className="flex items-start justify-between gap-2 flex-wrap">
            <div className="flex flex-col gap-1">
              <Skeleton className="bg-white-100 h-5 w-16" />
              <Skeleton className="bg-white-100 h-3.5 w-24" />
            </div>

            <div className="flex items-center gap-1 flex-wrap">
              <Skeleton className="bg-white-100 h-6 w-20" />
              <Skeleton className="bg-white-100 h-6 w-20" />
              <Skeleton className="bg-white-100 h-6 w-36" />
              <Skeleton className="bg-white-100 h-6 w-36" />
            </div>
          </div>

          <div className="flex items-end justify-between gap-2 flex-wrap">
            <div className="flex items-center gap-1 flex-wrap">
              <Skeleton className="bg-white-100 h-6 w-28" />
              <Skeleton className="bg-white-100 h-6 w-24" />
            </div>
          </div>
        </Box>

        <Skeleton className="bg-white-100 size-[88px] rounded-full shrink-0" />
      </div>

      <Box className="flex-1 p-3 rounded-lg flex flex-col gap-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <Box key={i} className="px-2.5 py-3 rounded-lg flex items-center justify-between min-h-12">
            <Skeleton className="bg-white-100 h-6 w-8" />
            <div className="flex items-center gap-1">
              <Skeleton className="bg-white-100 h-6 w-16" />
              <Skeleton className="bg-white-100 h-6 w-14" />
              <Skeleton className="bg-white-100 h-6 w-24" />
            </div>
          </Box>
        ))}
      </Box>
    </div>
  );
}

export default MaintenanceEstablishmentChoiceAuctionEntriesShowLoading;
